import React from "react";
import { PieChart, Pie } from "recharts";

let arr = []

const calculateValue = (value) => {
  arr = [
    { name: value.data.Division, value: parseFloat(value.data.GreenPercentage.Post), fill: '#69be5e' },
    { name: value.data.Division, value: parseFloat(value.data.AmberPercentage.Post), fill: '#fe9f4b' },
    { name: value.data.Division, value: parseFloat(value.data.RedPercentage.Post), fill: '#e3565a' }
  ]
}

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" fontSize={12} textAnchor={'middle'} dominantBaseline="central">
      {`${value?.toFixed(1)}%`}
    </text>
  );
};

const PostOpsoPratDashboardPieChart = (props) => {
  calculateValue(props); // Value conversion for graph mapping
  return (
    <div>
      <PieChart width={200} height={200}>
        <Pie
          data={arr}
          cx={95}
          cy={95}
          innerRadius={"60%"}
          outerRadius={"100%"}
          labelLine={false}
          label={renderCustomizedLabel}
          startAngle={90}
          endAngle={-270}
          fill={arr.fill}
        />
      </PieChart>

      <div style={{ fontSize: '14px' }}>
        {arr[0].name}
      </div>
    </div>
  );
};

export default PostOpsoPratDashboardPieChart;
